/**
 * Objeto representando um item do relatório de avaliações por data
 */
class AvaliacaoDataItem {

    /**
     * Cria uma nova instância do objeto
     * @param {String} data Data da avaliação como texto
     * @param {Number} quantidade Quantidade de avaliações realizadas no dia
     */
    constructor (data, quantidade) {
        /** @member {Date} data Data da avaliação */
        this.data = data;
        /** @member {Number} quantidade Quantidade de avaliações realizadas no dia */
        this.quantidade = quantidade;
    }

    /**
     * Cria uma cópia do objeto
     * @param {AvaliacaoDataItem} origem Objeto a ser clonado
     * @return {AvaliacaoDataItem} Cópia do objeto original
     */
    static clone(origem) {
        return new AvaliacaoDataItem(origem.data, origem.quantidade);
    }
}

/**
 * Objeto representando um relatório de avaliações por dia
 */
class AvaliacaoData {
    /**
     * Cria uma nova instância do objeto
     * @param {Array<AvaliacaoDataItem>} ultimos30dias Avaliações realizadas nos últimos 30 dias
     * @param {Array<AvaliacaoDataItem>} ultimos6meses Avaliações realizadas nos últimos 6 meses
     * ultimos6meses
     */
    constructor(ultimos30dias, ultimos6meses) {
        /** @member {Array<AvaliacaoDataItem>} ultimos30dias Avaliações realizadas nos últimos 30 dias */
        this.ultimos30dias = ultimos30dias ?? [ ];
        /** @member {Array<AvaliacaoDataItem>} ultimos6meses Avaliações realizadas nos últimos 6 meses */
        this.ultimos6meses = ultimos6meses ?? [ ];
    }

    /**
     * Cria uma cópia do objeto
     * @param {AvaliacaoData} origem Objeto a ser clonado
     * @returns {AvaliacaoData} Cópia do objeto original
     */
    static clone(origem) {
        let ultimos30dias = [];
        if (origem.ultimos30dias)
            ultimos30dias = origem.ultimos30dias.map(item => AvaliacaoDataItem.clone(item));

        let ultimos6meses = [];
        if (origem.ultimos6meses)
            ultimos6meses = origem.ultimos6meses.map(item => AvaliacaoDataItem.clone(item));

        return new AvaliacaoData(ultimos30dias, ultimos6meses);
    }
}

export default AvaliacaoData;
export { AvaliacaoDataItem };